import React from 'react'
import { LuArrowLeft } from 'react-icons/lu'
import { Link, LinkProps } from 'react-router'

import { cn } from '@/lib/utils'

import { Button } from '../ui/button'

type Props = LinkProps &
  BackLinkProps & {
    variant?: React.ComponentProps<typeof Button>['variant']
  }

export interface BackLinkProps {
  label: string
  to: string
}

const BackLink: React.FC<Props> = ({
  className,
  label,
  variant = 'ghost',
  to,
  ...props
}) => (
  <Button asChild variant={variant}>
    <Link to={to} className={cn('mb-4 block text-black', className)} {...props}>
      <LuArrowLeft /> {label}
    </Link>
  </Button>
)

export default BackLink
